import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Col, Row } from 'reactstrap';

import { getSetting } from '../../../../helpers/Settings';
import { prefixSuffixLabels, prefixSuffixSeparators } from '../../../../helpers/Files';

import FileUploadAddPrefixSuffix from '../../../Upload/AddPrefixSuffix';
import ErrorBoundary from '../../../ErrorBoundary';
import SettingsEditButtons from '../EditButtons';
import SettingsItemsWrapper from '../Item/ItemsWrapper';
import TrialNotice from '../../../TrialNotice';
import UpgradePlanButton from '../../../UpgradePlanButton';

const SettingsPrefixSuffix = (props) => {
  const {
    title,
    handlePrefixAndSuffix,
    saving,
    handleSave,
    unsaved,
  } = props;

  const settingValue = getSetting('file_name_prefix_and_suffix');

  const [includePrefix, setIncludePrefix] = useState(false);
  const [includeSuffix, setIncludeSuffix] = useState(false);

  const [prefixLabel, setPrefixLabel] = useState(prefixSuffixLabels[0].value);
  const [suffixLabel, setSuffixLabel] = useState(prefixSuffixLabels[0].value);

  const [prefixSeparator, setPrefixSeparator] = useState(prefixSuffixSeparators[0].value);
  const [suffixSeparator, setSuffixSeparator] = useState(prefixSuffixSeparators[0].value);

  const handlePrefixLabel = (value) => {
    setPrefixLabel(value);
    handlePrefixAndSuffix('prefix', 'label', value);
  };
  const handleSuffixLabel = (value) => {
    setSuffixLabel(value);
    handlePrefixAndSuffix('suffix', 'label', value);
  };

  const handlePrefixSeparator = (value) => {
    setPrefixSeparator(value);
    handlePrefixAndSuffix('prefix', 'separator', value);
  };
  const handleSuffixSeparator = (value) => {
    setSuffixSeparator(value);
    handlePrefixAndSuffix('suffix', 'separator', value);
  };

  const handleIncludePrefix = (value) => {
    setIncludePrefix(value);
    handlePrefixAndSuffix('prefix', 'include', value);
  };
  const handleIncludeSuffix = (value) => {
    setIncludeSuffix(value);
    handlePrefixAndSuffix('suffix', 'include', value);
  };

  useEffect(() => {
    const newPrefixLabel = prefixSuffixLabels.find(
      label => label.value === settingValue.prefix.label,
    );
    const newSuffixLabel = prefixSuffixLabels.find(
      label => label.value === settingValue.suffix.label,
    );

    const newPrefixSeparator = prefixSuffixSeparators.find(
      separator => separator.value === settingValue.prefix.separator,
    );
    const newSuffixSeparator = prefixSuffixSeparators.find(
      separator => separator.value === settingValue.suffix.separator,
    );

    setPrefixLabel(newPrefixLabel?.value);
    setSuffixLabel(newSuffixLabel?.value);
    setPrefixSeparator(newPrefixSeparator?.value);
    setSuffixSeparator(newSuffixSeparator?.value);
  }, [
    settingValue.prefix.label,
    settingValue.prefix.separator,
    settingValue.suffix.label,
    settingValue.suffix.separator,
  ]);

  return (
    <ErrorBoundary>
      <div className="settings-inner-content prefix-suffix-content">
        <Row>
          <Col>
            <h3>
              {title}
              <UpgradePlanButton feature="file-name-prefix-suffix" />
            </h3>
          </Col>
        </Row>
        <TrialNotice feature="file-name-prefix-suffix" className="pl-0" />
        <FileUploadAddPrefixSuffix
          includePrefix={includePrefix}
          handleIncludePrefix={handleIncludePrefix}
          includeSuffix={includeSuffix}
          handleIncludeSuffix={handleIncludeSuffix}
          handlePrefixLabel={handlePrefixLabel}
          prefixLabel={prefixLabel}
          handlePrefixSeparator={handlePrefixSeparator}
          prefixSeparator={prefixSeparator}
          handleSuffixLabel={handleSuffixLabel}
          suffixLabel={suffixLabel}
          handleSuffixSeparator={handleSuffixSeparator}
          suffixSeparator={suffixSeparator}
          ignoreDisabled={true}
          identifier="admin-settings"
        />
        <SettingsItemsWrapper
          {...props}
        />
      </div>
      <SettingsEditButtons
        saving={saving}
        handleSave={handleSave}
        unsaved={unsaved}
      />
    </ErrorBoundary>
  );
};

SettingsPrefixSuffix.propTypes = {
  title: PropTypes.string.isRequired,
  handlePrefixAndSuffix: PropTypes.func.isRequired,
  saving: PropTypes.bool.isRequired,
  handleSave: PropTypes.func.isRequired,
  unsaved: PropTypes.bool.isRequired,
};

export default SettingsPrefixSuffix;
